import { useState } from 'react';

// The first item is the vehicle's main image. Arrow buttons cover touch devices, where HTML5 drag-and-drop is unreliable.
function ReorderableImageGrid({ items, onMove, onRemove }) {
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const endDrag = () => {
    setDragIndex(null);
    setOverIndex(null);
  };

  return (
    <div className="upload-preview-grid">
      {items.map((item, index) => (
        <div
          key={item.id}
          className={`upload-preview-item current-image-item reorder-item${
            dragIndex === index ? ' dragging' : ''
          }${overIndex === index && dragIndex !== index ? ' drag-over' : ''}`}
          draggable
          onDragStart={(event) => {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', String(index));
            setDragIndex(index);
          }}
          onDragOver={(event) => {
            event.preventDefault();
            setOverIndex(index);
          }}
          onDrop={(event) => {
            event.preventDefault();
            if (dragIndex !== null && dragIndex !== index) {
              onMove(dragIndex, index);
            }
            endDrag();
          }}
          onDragEnd={endDrag}
        >
          {index === 0 && <span className="main-image-badge">Main</span>}
          <button
            type="button"
            className="current-image-remove"
            onClick={() => onRemove(index)}
            aria-label="Remove photo"
          >
            ×
          </button>
          <img src={item.url} alt={item.alt} draggable={false} />
          <div className="reorder-controls">
            <button
              type="button"
              className="reorder-btn"
              onClick={() => onMove(index, index - 1)}
              disabled={index === 0}
              aria-label="Move photo earlier"
            >
              ◀
            </button>
            <button
              type="button"
              className="reorder-btn"
              onClick={() => onMove(index, index + 1)}
              disabled={index === items.length - 1}
              aria-label="Move photo later"
            >
              ▶
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReorderableImageGrid;
